import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	getManagementList,
	getOrganizationalChart,
} from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditManagementModal from './Add_Edit/AddEditManagementModal';
import DeleteManagementModal from './Delete/DeleteManagement';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import OrganizationalChart from './Components/OrganizationalChart';

const ManagementsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorManagements = createSelector(
		state => state.Managements,
		management => ({
			managementList: management.managementList,
			chart: management.itemOrganizationalChart,
			isLoadingList: management.isLoadingList,
			isManagementSuccess: management.isManagementSuccess,
			error: management.error,
			isAdding: management.isAdding,
			isAdded: management.isAdded,
			isAddError: management.isAddError,
			isUpdating: management.isUpdating,
			isUpdated: management.isUpdated,
			isUpdateError: management.isUpdateError,
			isDeleting: management.isDeleting,
			isDeleted: management.isDeleted,
			isDeleteError: management.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { managementList, chart, isLoadingList } =
		useSelector(selectorManagements);

	useEffect(() => {
		dispatch(getManagementList());
	}, []);

	useEffect(() => {
		dispatch(getOrganizationalChart());
	}, []);

	const [dataManagement, setDataManagement] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Management
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = management => {
		setDataManagement(management);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = management => {
		setDataManagement(management);
		handleToggleModal();
	};

	// const OrganizationalChart = ({ data }) => {

	// 	console.log(data);
	// 	const renderTree = nodes => {
	// 		return nodes.map(node => (
	// 			<div className='first-list' key={node.id}>
	// 				<div className='list-wrap'>
	// 					<Link to='#' className='fw-medium text-primary'>
	// 						{node.name}
	// 					</Link>
	// 				</div>
	// 				{node.children && node.children.length > 0 && (
	// 					<ul className='second-list list-unstyled'>
	// 						{renderTree(node.children)}
	// 					</ul>
	// 				)}
	// 			</div>
	// 		));
	// 	};

	// 	return (
	// 		<div className='verti-sitemap'>
	// 			<ul className='mb-0 list-unstyled'>
	// 				<li className='p-0 parent-title'>
	// 					<Link to='#' className='fw-medium fs-14'>
	// 						Empresa
	// 					</Link>
	// 				</li>
	// 				<li>{renderTree(data)}</li>
	// 			</ul>
	// 		</div>
	// 	);
	// };

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'management',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const managementData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(managementData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const managementData =
														cellProps.row.original;
													handleClickDelete(managementData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto', },
			// { header: 'Nombre Centro Costo', accessorKey: 'cost_center_name', size: 'auto', },
			// { header: 'Código Centro Costo', accessorKey: 'cost_center', size: 'auto', },
			{ header: 'Dependencia', accessorKey: 'management.name', size: 'auto', },
			{ header: 'Empresa', accessorKey: 'company.name', size: 'auto', },
		],
		[handleClickEdit]
	);

	console.log(chart);
	return (
		<React.Fragment>
			<Row>
				<Col lg={5}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataManagement({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Departamento
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={managementList || []}
								isLoadingData={isLoadingList}
								nameFile={'departamento'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
												setIsEdit(false);
												setDataManagement({});
												handleToggleModal();
											},
										title: 'Crear Departamento',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>

				<Col sm={7} className='department-organizational-organigrama'>
					<Card className='card-height-100 department-organizational-chart'>
						<CardHeader className='p-2 align-items-center d-flex'>
							<h5 className='card-title mb-0 flex-grow-1'>
								Organigrama
							</h5>
						</CardHeader>
						<CardBody>
							<OrganizationalChart data={chart} />
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditManagementModal
				dataManagement={dataManagement}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteManagementModal
				dataManagement={dataManagement}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ManagementsList;
